import { PANEL_TYPES } from '~/constants/editor';

export const layoutInitialState = {
    global: {
        borderEnableAutoHide: true,
    },
    borders: [
        {
            type: 'border',
            size: 423,
            location: 'left',
            children: [
                {
                    type: 'tab',
                    id: PANEL_TYPES.ANNOTATIONS,
                    name: 'Annotations',
                    component: PANEL_TYPES.ANNOTATIONS,
                },
                {
                    type: 'tab',
                    id: PANEL_TYPES.SUMMARY,
                    name: 'Summary',
                    component: PANEL_TYPES.SUMMARY,
                },
            ],
        },
    ],
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                weight: 50,
                children: [
                    {
                        type: 'tabset',
                        weight: 17.2,
                        children: [
                            {
                                type: 'tab',
                                id: PANEL_TYPES.EVENTS,
                                name: 'Events',
                                component: PANEL_TYPES.EVENTS,
                            },
                            {
                                type: 'tab',
                                id: PANEL_TYPES.SPO2,
                                name: 'SpO2',
                                component: PANEL_TYPES.SPO2,
                            },
                            {
                                type: 'tab',
                                id: PANEL_TYPES.HR,
                                name: 'Heart Rate',
                                component: PANEL_TYPES.HR,
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        weight: 17.2,
                        children: [
                            {
                                type: 'tab',
                                id: PANEL_TYPES.POSITIONS,
                                name: 'Positions',
                                component: PANEL_TYPES.POSITIONS,
                            },
                        ],
                        active: true,
                    },
                    {
                        type: 'tabset',
                        weight: 74.3,
                        children: [
                            {
                                type: 'tab',
                                id: PANEL_TYPES.CHANNELS,
                                name: 'Channels',
                                component: PANEL_TYPES.CHANNELS,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
